import type { VoidFunctionComponent } from 'react';

import { formatCount, prettyNumber } from '../../../../shared/utils';
import { Badge } from '../Badge';

type Props = {
  count: number;
  isLoading?: boolean;
};

/**
 * Displays a count badge to the right of the children.
 * Optionally accepts an isLoading, which if true will display "..." instead of the count.
 * Counts will be formatted as described in the formatCount function.
 */
const SubnavCountBadge: VoidFunctionComponent<Props> = ({ count, isLoading }) => {
  //  Ensure that we never show NaN as the count
  const isFiniteCount = Number.isFinite(count);
  const finiteCount = isFiniteCount ? count : 0;
  return (
    <Badge
      color="light-gray"
      shape="circle"
      size="micro"
      //  This will display the full count as a title if the count is >= 10,000
      title={count >= 10_000 ? prettyNumber(finiteCount) : undefined}
    >
      {isLoading || !isFiniteCount ? '...' : formatCount(finiteCount)}
    </Badge>
  );
};

export default SubnavCountBadge;
